import { useEffect, useState } from "react";
import AgentVoucherCard from "./AgentVoucherCard";
import Tab from "../../components/Tab/Tab";
import SearchInput from "../../components/SearchInput/SearchInput";
import FilterBy from "../../components/FilterBy/FilterBy";
import FooterBar from "../../components/LoanFooterBar/FooterBar";
import { selectedLoans } from "./UserData";
import axios from "../../axios/axios";
import { App, Button, Modal } from "antd";
import { useSelector } from "react-redux";
import LoaderComp from "../../components/LoaderComp";
import { toast } from "react-toastify";

const sortOptions = [
  { label: "Interest rate: Low - High", value: "asc" },
  { label: "Interest rate: High - Low", value: "desc" },
  { label: "Name A-Z", value: "name_asc" },
  { label: "Name Z-A", value: "name_desc" },
];

const AgentDetails = ({
  ApplicationId,
  applicationData,
  GetApplicationInfo,
  cartItems,
  Step2Validation
}) => {
  const floorAppFormDetails = useSelector(
    (state) => state?.newFloorApplication?.floorAppFormDetails
  );
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [AgentDetails, setAgentDetails] = useState([]);
  const [applyFilters, setApplyFilters] = useState({
    search_key: "",
    is_featured: null,
    sortKey: "interest_from",
    sortOrder: "asc",
  });
  const [sortByValue, setSortByValue] = useState("asc");

  const [warningModal, setWarningModal] = useState(false);

  const AddToCart = async (data) => {
    const dataObj = {
      cart: [data],
    };
    try {
      const resp = await axios.post(
        `flooring/application/cart/${ApplicationId}`,
        dataObj
      );
      if (resp.status < 400) {
        GetApplicationInfo();
        toast.success(resp.data?.message);
      }
    } catch (err) {
      toast.error("Item not added to cart..!");
    }
  };

  const RemoveCartItem = async (cartId, multi) => {
    const resp = await axios.delete(
      `/flooring/application/cartDelete/${cartId}`
    );
    if (resp.status < 400) {
      GetApplicationInfo();
      if (multi !== undefined) {
        if (multi) {
          toast.success(resp.data?.message);
        }
      } else {
        toast.success(resp.data?.message);
      }
    }
  };
  const RemoveMultipleItems = (deselectedItems) => {
    if (deselectedItems?.length > 0 && deselectedItems !== undefined) {
      deselectedItems?.map((it, index) => {
        return RemoveCartItem(it, index + 1 == deselectedItems?.length);
      })
    }
  }

  const CleartCart = async () => {
    const resp = await axios.delete(`/flooring/application/cartDeleteAll/${ApplicationId}`);
    if (resp.status < 400) {
      GetApplicationInfo();
      Step2Validation([]);
      toast.success(resp.data?.message);
    }
  }

  const handleSortBy = (label, value) => {
    setSortByValue(value);
    // setApplyFilters({
    //   ...applyFilters,
    //   sortOrder: value?.includes("name") ? value?.slice(
    //     value.indexOf("_") + 1,
    //     value.length
    //   ) : value,
    // });
    if (label === "Interest rate: High - Low") {
      setApplyFilters({ ...applyFilters, sortKey: "interest_to", sortOrder: value });
    } else if (label === "Interest rate: Low - High") {
      setApplyFilters({ ...applyFilters, sortKey: "interest_from", sortOrder: value });
    } else {
      setApplyFilters({
        ...applyFilters,
        sortKey: "agentname", sortOrder: value?.includes("name") ? value?.slice(
          value.indexOf("_") + 1,
          value.length
        ) : value
      });
    }
  };

  const tabs = [
    `All Agents (${AgentDetails?.length})`,
    `Featured (${AgentDetails?.length})`,
  ];

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    setApplyFilters({
      ...applyFilters,
      is_featured: tabIndex == 0 ? null : 1,
    });
  };

  const handleSearchChange = (e) => {
    setApplyFilters({
      ...applyFilters,
      search_key: e.target.value,
    });
  };

  const GetAgentDetails = async () => {
    setLoading(true);
    const resp = await axios.post(
      `/flooring/application/products/${ApplicationId}`,
      applyFilters
    );
    if (resp.status < 400) {
      setAgentDetails(resp.data?.data?.agents);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const GetApplicationData = async () => {
    const resp = await axios.get(
      `flooring/application/show/${floorAppFormDetails?.appId}`
    );
    if (resp?.status < 400) {
      const temp = resp.data?.data?.vehicleInfo;
      if (temp?.intended_floor_amount !== undefined) {
        if (
          temp?.intended_floor_amount == "" ||
          temp?.intended_floor_amount == null
        ) {
          setWarningModal(true);
        } else {
          setWarningModal(false);
        }
      }
    }
  };
  const handleApplyLoan = () => { };

  useEffect(() => {
    GetAgentDetails();
  }, [applyFilters]);

  useEffect(() => {
    GetApplicationData();
  }, []);

  return (
    <div>
      <section className="agent-step-section">
        <h2>Agent Selection</h2>
        <p>
          The flooring applications below will be sent to the following agent(s)
          for approval.
        </p>
        <p>
          *Final Interest Rate and Admin Fee will be provided once the agent has
          vet through your application, rates below are for reference only.
        </p>
        <div className="tab-section agent-tab">
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          <div className="input-one-line !items-center">
            <FilterBy
              defaultName="Filter"
              sortOptions={sortOptions}
              value={sortByValue}
              handleSortBy={handleSortBy}
            />
            <SearchInput onChange={handleSearchChange} value={null} />
          </div>
        </div>
      </section>
      {loading ? (
        <section className="mb-[100px]">
          <LoaderComp />
        </section>
      ) : (
        <section className="mb-[100px]">
          {activeTab === 0 && AgentDetails?.length > 0 && (
            <AgentVoucherCard
              AgentDetails={AgentDetails}
              AddToCart={AddToCart}
              cartItems={cartItems}
              RemoveCartItem={RemoveCartItem}
            />
          )}
          {activeTab === 1 && AgentDetails?.length > 0 && (
            <AgentVoucherCard
              AgentDetails={AgentDetails}
              AddToCart={AddToCart}
              cartItems={cartItems}
              RemoveCartItem={RemoveCartItem}
            />
          )}
        </section>
      )}
      <FooterBar
        selectedLoanData={selectedLoans}
        handleApplyLoan={handleApplyLoan}
        cartItems={cartItems}
        RemoveCartItem={RemoveCartItem}
        RemoveMultipleItems={RemoveMultipleItems}
        CleartCart={CleartCart}
      />
      <Modal
        open={warningModal}
        title="Info!"
        footer={[
          <Button
            type="primary"
            onClick={() => {
              setWarningModal(false);
            }}
          >
            Ok
          </Button>,
        ]}
      >
        <p>
          As you have not submitted the Intended Floor Amount in the previous
          step, Some of the Agensts below may not display eligble vouchers.
        </p>
      </Modal>
    </div>
  );
};
export default AgentDetails;
